import styled, {css} from 'styled-components';
import marginProps from 'styled/shared-props/margin';
import paddingProps from 'styled/shared-props/padding';

export const StyledSvg = styled.svg`
    width: 100%;
    height: 100%;
    ${marginProps}
    ${paddingProps}
`;

